export default {
  default: {
    createShareLinkToast: 'Share Link Created Successfully',
    deleteShareLink: 'Share Link Deleted Successfully',
    updateShareLink: 'Share Link Updated Successfully',
    send: 'Messages queued for delivery',
  },
}
